export class PatientActions {
  public static CLEAR_ERROR_PATIENT = 'CLEAR_ERROR_PATIENT';
}

export function clearError() {
  return {
    type: PatientActions.CLEAR_ERROR_PATIENT,
    data: null,
  };
}
